import Notification from './notification';

const generateRndIdentifier = () => `message-${Math.random().toString(36).substring(7)}`;

const checkMessage = (list, id) => {
  if (id == null) {
    throw new Error('cannot set notification data without id (got null)');
  }
  if (!list.some((m) => m.id === id)) {
    throw new Error(`cannot find notification message with id: ${id}`);
  }
};

const initialState = {
  list: [],
};

const mutations = {
  addMessage(state, message) {
    if (!state.list.includes(message)) {
      state.list.push(message);
    }
  },
  removeMessage(state, idx) {
    state.list.splice(idx, 1);
  },
  setMessages(state, list) {
    state.list = list;
  },
  updateMessage(state, messageData) {
    const { id } = messageData;
    const idx = state.list.findIndex((m) => m.id === id);
    Object.assign(state.list[idx], messageData);
    // force list update to render new notificacion properties
    state.list = state.list.slice();
  },
};

const actions = {
  createNotificationMessage({ commit, state }, data) {
    let $id = data.id;
    const checkIdentifier = (_id) => _id == null || state.list.some((m) => m.id === _id);
    while (checkIdentifier($id)) {
      $id = generateRndIdentifier();
    }
    const notificationMessage = new Notification({
      ...data,
      visible: typeof data.visible === 'boolean' ? data.visible : true,
      id: $id,
    });

    commit('addMessage', notificationMessage);
    return notificationMessage.id;
  },
  removeNotificationMessage({ commit, state }, id) {
    const idx = state.list.findIndex((m) => m.id === id);
    if (idx >= 0) {
      commit('removeMessage', idx);
    }
  },
  clearNotificationMessages({ commit }) {
    commit('setMessages', []);
  },
  updateMessage({ commit, state }, data) {
    checkMessage(state.list, data.id);
    commit('updateMessage', data);
  },
};

export default {
  namespaced: true,
  state: initialState,
  mutations,
  actions,
};
